import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchValues = this.props.selectedSearchValues;
    const tableData = this.props.tableData;
    return (
      <div>
        <h2><center><u>Invoice Payment History Report</u></center></h2>
        <div>&nbsp;</div>
        <h3><center>Group : {searchValues.groupName}</center></h3>
        <h3><center>Factory : {searchValues.factoryName}</center></h3>
        <h3><center>Date : {(new Date(searchValues.date)).toLocaleDateString()}</center></h3>
        <div>&nbsp;</div>
        <Box minWidth={1050} display="flex" justifyContent="flex-end" p={2}>
          <TableContainer style={{ marginTop: 16, padding: 8, paddingBottom: '20px' }}>
            <Table size="small" aria-label="report table" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 110 }} align="center">Invoice Number</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 110 }} align="center">Ref Number</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 130 }} align="center">Supplier</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 90 }} align="center">Invoice Date</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 130 }} align="center">Invoice Amount (Rs.)</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 100 }} align="center">Paid Amount (Rs.)</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 120 }} align="center">Outstanding (Rs.)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData && tableData.map((item, idx) => (
                  <TableRow key={idx}>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.voucherCode}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.invoiceReference}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{item.supplierName}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{item.createdDate ? (new Date(item.createdDate)).toLocaleDateString() : "-"}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 90 }} align="left">{item.amount}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130 }} align="left">{item.paidAmount}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 100 }} align="right">{item.remainingAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <div>&nbsp;</div>
      </div>
    );
  }
}